/* BOSSVI · pack de acabado (upsell). Un solo botón, «Añadir el pack», en tres sitios: la tarjeta de
   la ficha (debajo de comprar), el pop-up que sale al agregar al carrito y la tarjeta del carrito.
   La medida NO manda a otra página: se elige dentro del mismo recuadro (paso 2 del pop-up en la
   ficha, lista desplegable en el carrito) y al tocarla se añade y se abre el cajón.
   Se carga desde snippets/bossvi-upsell.liquid. */
if (!window.__bvUpsell) {
  window.__bvUpsell = true;

  /* los rellena el pop-up si existe en la página (solo está en las fichas con complementarios) */
  var bvCerrarPopup = null;
  var bvAbrirMedidas = null;

  /* ---------- Clics: abrir medidas y añadir al carrito ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* «Añadir el pack» cuando hay varias medidas: abre el paso de medidas del pop-up */
    var abrir = t.closest('[data-bv-medidas]');
    if (abrir) {
      e.preventDefault();
      if (bvAbrirMedidas) bvAbrirMedidas();
      return;
    }

    /* «Añadir el pack» en la tarjeta del carrito: despliega las medidas ahí mismo */
    var desplegar = t.closest('[data-bv-medidas-carrito]');
    if (desplegar) {
      e.preventDefault();
      var caja = desplegar.closest('.bv-up__item');
      var lista = caja ? caja.querySelector('.bv-up__medidas') : null;
      if (lista) {
        lista.hidden = false;
        desplegar.hidden = true;
      }
      return;
    }

    var btn = t.closest('[data-bv-upsell-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var variantId = Number(btn.getAttribute('data-bv-upsell-add'));
    var comp = btn.closest('cart-items-component');
    var sectionId = comp && comp.dataset ? comp.dataset.sectionId : null;
    var stay = btn.hasAttribute('data-bv-stay');
    var cerrar = btn.hasAttribute('data-bv-cerrar');
    var label = btn.textContent;
    var added = null;
    btn.disabled = true;
    if (stay) btn.textContent = 'Añadiendo…';
    /* 4 nov 2026: el pack añadido desde la ficha entra con _origen = pack:<planta> (para medir) */
    var origen = btn.getAttribute('data-bv-origen');
    var linea = { id: variantId, quantity: 1 };
    if (origen) linea.properties = { _origen: origen };
    var body = { items: [linea], sections_url: window.location.pathname };
    if (sectionId) body.sections = sectionId;
    var addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) ? window.Theme.routes.cart_add_url : '/cart/add.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw new Error(json.description || json.message || 'add failed');
          return json;
        });
      })
      .then(function (json) {
        added = json;
        var itemCount = null;
        if (sectionId && json.sections && json.sections[sectionId]) {
          var doc = new DOMParser().parseFromString(json.sections[sectionId], 'text/html');
          var hidden = doc.querySelector('[ref="cartItemCount"]');
          if (hidden) itemCount = parseInt(hidden.textContent, 10);
        }
        if (itemCount === null || isNaN(itemCount)) {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (x) { return x.json(); })
            .then(function (cart) { return cart.item_count; });
        }
        return itemCount;
      })
      .then(function (itemCount) {
        if (stay) {
          btn.textContent = 'Añadido ✓';
          btn.classList.add('is-added');
          btn.disabled = true;
        }
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: added,
            sourceId: 'bossvi-upsell',
            data: { source: 'bossvi-upsell', itemCount: itemCount, variantId: String(variantId), sections: added.sections }
          }
        }));
        /* elegida la medida en el pop-up: se cierra y se abre el cajón con el pack dentro */
        if (cerrar && bvCerrarPopup) bvCerrarPopup();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'No disponible';
        setTimeout(function () { btn.textContent = label; }, 2500);
      });
  });

  /* ---------- Pop-up «Completa tu planta» en la ficha ---------- */
  (function () {
    var modal = document.getElementById('bv-acabados');
    /* se busca cada vez: el tema vuelve a pintar el cajón cada vez que cambia el carrito */
    function elCajon() { return document.querySelector('cart-drawer-component'); }
    function cajonAbierto() {
      var d = elCajon();
      var dlg = d ? d.querySelector('dialog') : null;
      return !!(dlg && dlg.open);
    }
    function openDrawer() {
      var d = elCajon();
      if (d && typeof d.open === 'function') {
        try { d.open(); } catch (err) {}
      }
    }
    /* el cajón no se abre solo mientras hay pop-up: primero el pack, luego el carrito */
    function closeDrawer() {
      var d = elCajon();
      if (!d) return;
      d.removeAttribute('auto-open');
      if (!cajonAbierto()) return;
      if (typeof d.close === 'function') { try { d.close(); } catch (err) {} }
      var dlg = d.querySelector('dialog');
      if (dlg && dlg.open) { try { dlg.close(); } catch (err) {} }
    }
    if (!modal) return;

    /* El tema abre el cajón solo cuando el <cart-drawer-component> lleva el atributo auto-open, y lo
       vuelve a pintar (con el atributo otra vez) cada vez que cambia el carrito, así que se abría por
       encima del pop-up. En esta página el cajón lo abrimos nosotros cuando toca: se quita siempre. */
    function quitarAutoOpen() {
      var d = elCajon();
      if (d && d.hasAttribute('auto-open')) d.removeAttribute('auto-open');
    }
    quitarAutoOpen();
    if (window.MutationObserver) {
      new MutationObserver(quitarAutoOpen).observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['auto-open']
      });
    }
    closeDrawer();

    var productId = modal.getAttribute('data-bv-product');
    var key = 'bv-acabados-' + productId;
    /* enlace de prueba: con ?acabados=ver en la dirección de la ficha, el pop-up vuelve a salir */
    if (/[?&]acabados=ver(&|$)/.test(window.location.search)) { try { sessionStorage.removeItem(key); } catch (err) {} }
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    function alreadyShown() { try { return sessionStorage.getItem(key) === '1'; } catch (err) { return false; } }
    function markShown() { try { sessionStorage.setItem(key, '1'); } catch (err) {} }

    var paso1 = modal.querySelector('[data-bv-paso="uno"]');
    var paso2 = modal.querySelector('[data-bv-paso="dos"]');
    /* 'compra' = se abrió al agregar la planta (al cerrar se abre el cajón);
       'tarjeta' = lo abrió el cliente desde la tarjeta de la ficha (al cerrar, no se abre nada) */
    var fuente = 'compra';

    /* ¿el pack ya está en el carrito? entonces no hace falta ofrecerlo */
    function packEnCarrito() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ids = (cart.items || []).map(function (i) { return String(i.variant_id); });
          var btns = modal.querySelectorAll('[data-bv-upsell-add]');
          for (var i = 0; i < btns.length; i++) {
            if (ids.indexOf(btns[i].getAttribute('data-bv-upsell-add')) !== -1) return true;
          }
          return false;
        })
        .catch(function () { return false; });
    }

    /* Vídeo: se intenta reproducir solo; si el móvil lo bloquea (ahorro de batería, «reducir
       movimiento», ahorro de datos) se queda la foto de portada con un botón de reproducir. */
    var video = modal.querySelector('video[data-bv-video]');
    function showPlay() { modal.classList.add('bv-acab--play'); }
    function hidePlay() { modal.classList.remove('bv-acab--play'); }
    function playVideo(fromUser) {
      if (!video) return;
      if (!video.getAttribute('src')) { video.setAttribute('src', video.getAttribute('data-bv-video')); video.load(); }
      if (reduceMotion && !fromUser) { showPlay(); return; }
      var p;
      try { p = video.play(); } catch (err) { showPlay(); return; }
      if (p && p.catch) p.catch(function () { showPlay(); });
    }
    if (video) {
      video.addEventListener('playing', hidePlay);
      video.addEventListener('error', function () { showPlay(); }, true);
    }

    function abrirHoja() {
      if (modal.open) return;
      closeDrawer();
      document.documentElement.classList.add('bv-lock');
      modal.showModal();
      playVideo(false);
      /* al añadir la planta el tema repinta el cajón y se abre solo por encima del pop-up:
         mientras el pop-up esté abierto, se cierra */
      var n = 0;
      var vigila = setInterval(function () {
        if (!modal.open || n++ > 20) { clearInterval(vigila); return; }
        closeDrawer();
      }, 150);
    }
    function mostrarPaso1() {
      if (paso1) paso1.hidden = false;
      if (paso2) paso2.hidden = true;
      modal.classList.remove('bv-acab--medidas');
      modal.classList.remove('bv-acab--sin-badge');
    }
    function mostrarMedidas() {
      if (!paso2) return;
      /* abierto desde la tarjeta de la ficha: no se ha añadido nada todavía, fuera el sello */
      if (!modal.open) { fuente = 'tarjeta'; modal.classList.add('bv-acab--sin-badge'); }
      modal.classList.add('bv-acab--medidas');
      if (paso1) paso1.hidden = true;
      paso2.hidden = false;
      markShown();
      abrirHoja();
    }
    function openModal() {
      if (modal.open) return;
      /* 4 nov 2026: a esta medida de la planta no le cabe ningún pack: no se ofrece */
      if (modal.hasAttribute('data-bv-sin-pack')) { openDrawer(); return; }
      fuente = 'compra';
      packEnCarrito().then(function (yaEsta) {
        if (yaEsta) { openDrawer(); return; }
        markShown();
        mostrarPaso1();
        abrirHoja();
      });
    }
    function closeModal(abrirCajon) {
      document.documentElement.classList.remove('bv-lock');
      if (video) { try { video.pause(); } catch (err) {} }
      if (modal.open) modal.close();
      mostrarPaso1();
      fuente = 'compra';
      if (abrirCajon !== false) openDrawer();
    }
    /* tras añadir el pack siempre se abre el cajón; al cerrar a mano, solo si venía de una compra */
    bvCerrarPopup = function () { closeModal(true); };
    bvAbrirMedidas = mostrarMedidas;

    document.addEventListener('cart:update', function (e) {
      var d = e.detail && e.detail.data ? e.detail.data : {};
      if (d.source === 'bossvi-upsell' || d.source === 'cart-items-component') return;
      if (d.source !== 'product-form-component' || d.didError || String(d.productId) !== String(productId)) {
        openDrawer();
        return;
      }
      if (alreadyShown()) { openDrawer(); return; }
      setTimeout(openModal, 250);
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bv-acab-play]')) { playVideo(true); return; }
      if (e.target.closest('[data-bv-acab-close]')) { closeModal(fuente === 'compra'); return; }
      if (e.target === modal) closeModal(fuente === 'compra');
    });
    modal.addEventListener('cancel', function (e) { e.preventDefault(); closeModal(fuente === 'compra'); });
  })();

  /* ---------- Pack de una sola medida (4 nov 2026, Ticket medio 3) ----------
     La tarjeta de la ficha trae el mapa «medida de la planta → pack que le cabe» (snippets/bossvi-ficha.liquid;
     la regla está en snippets/bossvi-medida-madera.liquid). Aquí se aplica a la tarjeta y al paso 1 del pop-up
     al cargar y cada vez que el cliente cambia de medida. Sin dato (null): todo se queda como antes. */
  (function () {
    function tarjeta() {
      var t = document.querySelectorAll('[data-bv-pack-una]');
      for (var i = 0; i < t.length; i++) {
        if (!t[i].closest('dialog, .quick-add-modal')) return t[i];
      }
      return null;
    }

    function mapa(t) {
      if (t.__bvMapa) return t.__bvMapa;
      var s = t.parentNode ? t.parentNode.querySelector('[data-bv-pack-mapa]') : null;
      try { t.__bvMapa = JSON.parse(s ? s.textContent : '{}'); } catch (e) { t.__bvMapa = {}; }
      return t.__bvMapa;
    }

    function varianteActual(t) {
      var forms = document.querySelectorAll('product-form-component');
      for (var i = 0; i < forms.length; i++) {
        var f = forms[i];
        if (f.closest('dialog, .quick-add-modal')) continue;
        if (String(f.dataset.productId) !== String(t.dataset.producto)) continue;
        var inp = f.querySelector('input[name="id"]');
        if (inp && inp.value) return String(inp.value);
      }
      return '';
    }

    /* «como antes»: precio «Desde …» y botón que abre las medidas (o añade la única que haya) */
    function comoAntes(btn, precio, t, modo) {
      if (precio) precio.textContent = t.dataset.bvDesde || '';
      if (!btn) return;
      btn.removeAttribute('data-bv-origen');
      btn.removeAttribute('data-bv-stay');
      btn.removeAttribute('data-bv-cerrar');
      if (Number(t.dataset.bvMulti) > 1) {
        btn.removeAttribute('data-bv-upsell-add');
        btn.setAttribute('data-bv-medidas', '');
        btn.removeAttribute('aria-label');
      } else {
        btn.removeAttribute('data-bv-medidas');
        btn.setAttribute('data-bv-upsell-add', t.dataset.bvVar);
        btn.setAttribute(modo, '');
        btn.setAttribute('aria-label', 'Añadir el pack al carrito');
      }
    }

    function poner(btn, precio, e, claseMed, modo, handle) {
      if (precio) {
        precio.innerHTML = '';
        var m = document.createElement('span');
        m.className = claseMed;
        m.textContent = e.m;
        precio.appendChild(m);
        precio.appendChild(document.createTextNode(e.p));
      }
      if (!btn) return;
      btn.removeAttribute('data-bv-medidas');
      btn.removeAttribute('data-bv-stay');
      btn.removeAttribute('data-bv-cerrar');
      btn.setAttribute(modo, '');
      btn.setAttribute('data-bv-upsell-add', String(e.id));
      btn.setAttribute('data-bv-origen', 'pack:' + handle);
      btn.setAttribute('aria-label', 'Añadir el pack de ' + e.m + ' al carrito');
    }

    function despejar(btn) {
      if (!btn) return;
      btn.disabled = false;
      btn.classList.remove('is-added');
      btn.textContent = 'Añadir el pack';
    }

    function aplicar(cambio) {
      var t = tarjeta();
      if (!t) return;
      /* sin variante leída o sin dato para ella: se deja lo que pintó el servidor */
      var vid = varianteActual(t);
      var m = mapa(t);
      if (!vid || !Object.prototype.hasOwnProperty.call(m, vid)) return;
      var e = m[vid];
      var tBtn = t.querySelector('[data-bv-pack-btn]');
      var tPre = t.querySelector('[data-bv-pack-precio]');
      var modal = document.getElementById('bv-acabados');
      var mBtn = modal ? modal.querySelector('[data-bv-paso="uno"] .bv-acab__cta') : null;
      var mPre = modal ? modal.querySelector('[data-bv-paso="uno"] .bv-acab__price') : null;
      if (cambio) { despejar(tBtn); despejar(mBtn); }

      t.hidden = (e === 'no');
      if (modal) {
        if (e === 'no') modal.setAttribute('data-bv-sin-pack', ''); else modal.removeAttribute('data-bv-sin-pack');
      }
      if (e && e.id) {
        poner(tBtn, tPre, e, 'bossvi-acabado__med', 'data-bv-stay', t.dataset.handle);
        poner(mBtn, mPre, e, 'bv-acab__med', 'data-bv-cerrar', t.dataset.handle);
      } else if (e === null) {
        comoAntes(tBtn, tPre, t, 'data-bv-stay');
        comoAntes(mBtn, mPre, t, 'data-bv-cerrar');
      }
    }

    document.addEventListener('variant:update', function (ev) {
      var t = tarjeta();
      if (!t) return;
      var d = ev.detail || {};
      if (d.data && d.data.productId && String(d.data.productId) !== String(t.dataset.producto)) return;
      /* el formulario cambia el id de la variante en el mismo evento: se aplica justo después */
      setTimeout(function () { aplicar(true); }, 0);
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { aplicar(false); });
    else aplicar(false);
  })();
}
